import script from "./ButtonsGroupComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonsGroupComponent.vue?vue&type=script&setup=true&lang=js"

import "./ButtonsGroupComponent.vue?vue&type=style&index=0&id=5707c76a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5707c76a"]])

export default __exports__